import React from 'react';
import Select, { components } from 'react-select';
import {
  ReactComponent as DropdownIcon,
} from '../../assets/dropdown-arrow.svg';
import infoIcon from '../../assets/plans/info.svg';
import styles from './DropdownCommon.module.css';
import IconTooltip, { TOOL_TIP_POSITION } from './IconTooltip';

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <DropdownIcon />
  </components.DropdownIndicator>
);

const getControlStyle = ({ isFocused }) => {
  if (isFocused) {
    return `${styles.control} ${styles.controlFocused}`;
  }
  return styles.control;
};

const getOptionStyle = ({ isSelected, isFocused }) => {
  if (isSelected) {
    return styles.optionSelected;
  }
  if (isFocused) {
    return styles.optionFocused;
  }
  return '';
};

export const DropdownCommon = ({
  className = '',
  labelClassName = '',
  options = [],
  label = '',
  tooltipText = '',
  tooltipPosition = TOOL_TIP_POSITION.start,
  value,
  onChange = () => { },
}) => (
  <div>
    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
    <label className={className}>
      <span className={`${styles.label} ${labelClassName}`}>
        {label}

        {tooltipText && (
          <IconTooltip
            backgroundColor="var(--deep-blue-main)"
            containerClassName={styles.tooltipClassName}
            description={tooltipText}
            descriptionClassName={styles.descriptionTooltip}
            icon={infoIcon}
            name={label}
            position={tooltipPosition}
          />
        )}
      </span>
    </label>

    <Select
      classNames={{
        control: getControlStyle,
        indicatorSeparator: () => styles.indicatorSeparator,
        option: getOptionStyle,
      }}
      components={{
        DropdownIndicator,
      }}
      onChange={onChange}
      options={options}
      value={value}
    />
  </div>
);
